import {connect} from '../../../app/connect';
import IssuesPermissionsBulkSelection from './IssuesPermissionsBulkSelection';

import {
  isFetchingPermissions,
  isBulkCreatingPermissions,
  getGroupedProjectActiveEntitiesPermissionsCandidates
} from '../../../app/selectors';
import {createBulkIssuesPermissions, showNotificationAction, trackEvent} from '../../../app/actions';

const mapStateToProps = state => ({
  isFetchingPermissions: isFetchingPermissions(state),
  isBulkCreatingPermissions: isBulkCreatingPermissions(state),
  permissionsCandidatesEntities: getGroupedProjectActiveEntitiesPermissionsCandidates(state)
});

const mapDispatchToProps = {
  createBulkIssuesPermissions,
  showNotificationAction,
  trackEvent
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssuesPermissionsBulkSelection);
